import request from "@/utils/http"; // 导入http中创建的axios实例
import qs from "qs"; // 根据需求是否导入qs模块
const uploadImgUrl = process.env.VUE_APP_UPLOADIMG_API;
// 经销商登录
export function logins(code) {
  return request.post(
    "/auth/login",
    qs.stringify({
      code: code
    })
  );
}
// 经销商登录
export function login(data) {
  return request.post("/auth/login/password", data);
}
// 图片上传
export function uploadImg(data) {
  return request.post(`${uploadImgUrl}`, data);
}
// 新增广告申请
export function adApply(params) {
  return request.post("/advert-apply/apply", params);
}
// 门店第一次确认
export function firstConfirm(data) {
  return request.post("/advert-apply/first-confirm", data);
}
// 门店再次确认
export function reconfirm(data) {
  return request.post("/advert-apply/reconfirm", data);
}
// 门店申请详情
export function adDetails(id) {
  return request.get(`/advert-apply/${id}`);
}
// 微信签名
export function weiXingSDK(url) {
  return request.get(`/wx/wxJsapiSignature?url=${url}`).then(res => {
    return res.result;
  });
}
// 申请列表
export function applyList(params) {
  return request.get(
    `/advert-apply/list?page=${params.page}&size=${params.size}&statusIn=${params.statusIn}`
  );
}
// 报销申请
export function reimbursement(params) {
  return request.post("/advert-apply/reimbursement", params);
}

// // 报销详情 已废除
// export function reimbursementDetail(id) {
//   return request.get(`/advert-apply/attachments/${id}`);
// }

// 报销详情
export function reimbursementDetail(id) {
  return request.get(`/advert-apply/attachments/${id}`);
}

// 费用报销列表
export function reimbursements(id) {
  return request.get(`/advert-apply/${id}/reimbursements`);
}
// 获取进货凭证
export function getCertificate(id) {
  return request.get(`/advert-apply/get_purchase_certificate/${id}`);
}
// 上传进货凭证
export function certificate(params) {
  return request.post("/advert-apply/upload_purchase_certificate", params);
}
// 上传进货凭证
export function submitReimburs(data) {
  return request.post("/advert-apply/submitReimburs", data);
}
// 重发短信
export function resendMessage(id) {
  return request.post(`/advert-apply/sendFirstConfirmSms?advertApplyId=${id}`);
}
